import { SectionTitle } from '@/components/SectionTitle'
import { pageMaxWidth, pageXPadding, pageYPadding } from '@/config'

const process: { title: string; description: string }[] = [
  {
    title: 'Consultation',
    description:
      'We begin with a detailed consultation to understand your vision, needs, and budget. This initial step sets the foundation for our design strategy.',
  },
  {
    title: 'Concept Development',
    description:
      'Our team develops creative concepts and design solutions tailored to your requirements. We present mood boards, color schemes, and layout options for your review.',
  },
  {
    title: 'Design Execution',
    description:
      'Once the concept is approved, we move to the execution phase. Our skilled team handles all aspects of the design implementation, ensuring high-quality craftsmanship and attention to detail.',
  },
  {
    title: 'Final Touches',
    description:
      'The final stage involves adding the finishing touches that bring your design to life. We conduct a thorough review to ensure everything meets our high standards and your satisfaction.',
  },
]
export const DesignProcess = () => {
  return (
    <section className={`${pageXPadding} ${pageYPadding} `}>
      <div className={`${pageMaxWidth} mx-auto flex flex-col gap-y-[12px]`}>
        <div className="flex justify-center">
          <SectionTitle variant="tertiary" title="Our Design Process" />
        </div>
        <div className="flex flex-col items-center gap-y-[10px]">
          {process.map(({ description, title }, index) => (
            <div
              key={index}
              className="flex w-full max-w-[626px] flex-col gap-y-[12px] px-[40px] py-[10px] font-nunito md:p-[20px]"
            >
              <h2 className="text-center text-[16px] font-bold leading-[19.2px] text-[#333333] md:text-[20px] md:leading-[24px] lg:text-[24px] lg:leading-[28.8px]">
                {title}
              </h2>
              <p className="text-center text-[12px] font-normal leading-[19.2px] text-[#333333] md:text-[14px] md:leading-[22.4px] lg:text-[16px] lg:leading-[25.6px]">
                {description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
